/**
 * Pendant qu'on attend le résultat d'une question de live (réponse envoyée), une phrase du prof écrite sous la
 * question : « Le prof relève 3 copies… ». Elle change au hasard toutes les quelques secondes, pour le suspense.
 * `copies` = nombre de joueurs qui ont déjà répondu (null : on ne le sait pas).
 */

type Line = (copies: string) => string;

const WITH_COUNT: readonly Line[] = [
  (c) => `Le prof relève ${c}…`,
  (c) => `Le prof ramasse ${c}…`,
  (c) => `Le prof corrige ${c}…`,
  (c) => `Le prof sort son stylo rouge : ${c} sur le bureau…`,
  (c) => `Chut… le prof relit ${c}.`,
  (c) => `Le prof compte les copies : ${c}…`,
  (c) => `Le prof feuillette ${c}…`,
  (c) => `Le prof fronce les sourcils devant ${c}…`,
];

const WITHOUT_COUNT: readonly string[] = [
  'Le prof relève les copies…',
  'Le prof ramasse les copies…',
  'Le prof sort son stylo rouge…',
  'Chut… le prof corrige.',
  'Le prof feuillette les copies…',
];

/** Combien de phrases différentes pour ce cas. */
export function teacherWaitingCount(copies: number | null): number {
  return copies != null && copies > 0 ? WITH_COUNT.length : WITHOUT_COUNT.length;
}

/** « 1 copie », « 3 copies ». */
export function copiesText(n: number): string {
  return `${n} ${n > 1 ? 'copies' : 'copie'}`;
}

/** La phrase n° `index` (modulo le nombre de phrases). */
export function teacherWaitingLine(index: number, copies: number | null): string {
  const n = teacherWaitingCount(copies);
  const i = ((index % n) + n) % n;
  if (copies != null && copies > 0) return WITH_COUNT[i]!(copiesText(copies));
  return WITHOUT_COUNT[i]!;
}

/** Une autre phrase que la précédente, au hasard (`rand` dans [0, 1[). */
export function nextTeacherWaitingIndex(prev: number, rand: number, count: number): number {
  if (count <= 1) return 0;
  const step = 1 + Math.floor(rand * (count - 1));
  return (prev + step) % count;
}
